import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// https://v5.reactrouter.com/web/guides/scroll-restoration
export const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Only `overflow` is saved and restored. Snapshotting the whole style attribute and writing
        // it back would rewind every other inline property on <html> to whatever it was on arrival,
        // including ui-kit's `--ui-sidebar-width`, which the sidebar may have changed since.
        const originalOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = "";

        window.scrollTo(0, 0);

        return () => {
            document.documentElement.style.overflow = originalOverflow;
        };
    }, [pathname]);

    return null;
};
